// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"db311ddf","491":"0d006b10"}[chunkId] + ".chunk.css";
};